import React, { useState } from 'react';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';

export default function NewsletterSignup() {
  const [nlSignupStatus, setNlSignupStatus] = useState('');
  const handleSubmitSignup = async (event) => {
    event.preventDefault(); // Prevent the default form submission behavior
    
    const formData = new FormData(event.target);
    const email = formData.get('email');
  
    if (!email || email.trim() === '') {
      alert('Please enter a valid email address.');
      return;
    }
  
    try {
      // Send the email to the Flask backend
      const response = await fetch(`${API_URL}/api/event_newsletter_su`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email }),
      });
  
      // Handle the server response
      if (response.ok) {
        const result = await response.json();
        setNlSignupStatus(result["message"]);
      } else {
        const error = await response.json();
        setNlSignupStatus(error["message"]);
      }
    } catch (error) {
      console.error('Error submitting the signup form:', error);
      setNlSignupStatus(error["message"])
    }
  };
  return (
    <>
      <div className="row justify-content-center pt-3" style={{ backgroundColor:"#d5f5e3" }} >
        <div className="col-md-6 col-sm-12 text-center bs-success-text-emphasis pb-3 rounded">
            <div className="form-outline">
              <form onSubmit={handleSubmitSignup}>
                  <input id="form_id" name="form_id" type="hidden" value="subscriptionform" />
                  Join our community!
                  <br/>
                  <input id="email" className="border mb-2 rounded-start text-center" name="email" required="" size="32" type="text" placeholder="my@email.com" />
                  <input
                    className="rounded-end border"
                    id="submit"
                    name="submit"
                    type="submit"
                    value="Signup"
                  />
                  <div className='text-center'>{nlSignupStatus}</div>
              </form>
            </div>
          </div>
      </div>
    </>
  );
}
